import React, { useContext } from 'react';
import arccosCaddieLogo from '../../assets/images/arccos-caddie-stacked.svg';
import { insightsContext } from '../../context/insightsContext';
import Styles from './About.module.scss';

const About = () => {
  const insights = useContext(insightsContext);
  const { state } = insights;
  const { data, currentInsight } = state;

  return (
    <div className={Styles.about}>
      <div className={Styles.logoContainer}>
        <img src={arccosCaddieLogo} alt='arccos-caddie-logo' />
      </div>
      <div>
        {
          data
          && <div className={Styles.descriptions}>
            <div className={Styles.bold}>{data[currentInsight].infoTitle}</div>
            <div>{data[currentInsight].infoAverageDesc}</div>
            <div>{data[currentInsight].infoAverageItems
              && data[currentInsight].infoAverageItems.map((item, index) => {
                return (
                  <li key={index} className={Styles.infoItemsList}>
                    {item}
                  </li>);
              })}</div>
            <div>{data[currentInsight].infoDescription}</div>
            <div className={Styles.bold}>{data[currentInsight].aboutTitle}</div>
            <div
              className={Styles.pingLinks}
              dangerouslySetInnerHTML={{
                __html: data[currentInsight].aboutDescription,
              }}></div>
          </div>
        }
      </div>
    </div>
  );
};

export default About;
